import { render, staticRenderFns } from "./BuyVip.vue?vue&type=template&id=7b4f9c89&scoped=true&lang=html"
import script from "./BuyVip.vue?vue&type=script&lang=js"
export * from "./BuyVip.vue?vue&type=script&lang=js"
import style0 from "./BuyVip.vue?vue&type=style&index=0&id=7b4f9c89&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f9c89",
  null
  
)

export default component.exports